import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, FieldArray, reduxForm } from "redux-form";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import { MutationDetectionIdentifier } from "./MutationDetectionIdentifier.jsx";
import { MutationDetectionSequence } from "./MutationDetectionSequence.jsx";
import * as assayActions from "../../../actions/assays.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import _ from "underscore";
import "../AssayCreate.scss";

export const MutationDetectionForm = ({ fields, custom }) => {
  const validatedAssayDetails = (custom && custom.validatedAssayDetails) || {};
  const formValues =
    custom &&
    custom.formObj &&
    custom.formObj.values &&
    custom.formObj.values.mutationDetectionForm;

    const targetByValue = custom &&
    custom.formObj &&
    custom.formObj.values && custom.formObj.values.targetby;

  return (
    <div>
      {fields.map((mutationDetectionForm, index) => {
        //const formobj = formValues && formValues[index];
        //const values = formValues && formValues[index];

        return (
          <Fragment key={index}>
            <div className="row">
              {targetByValue && targetByValue === "identifier" && (
                <div className="col">
                  <Field
                    name={`${mutationDetectionForm}.mutationdetectionidentifier`}
                    component={MutationDetectionIdentifier}
                    index={index}
                    custom={custom}
                  />
                </div>
              )}
              {targetByValue && targetByValue === "sequence" && (
                <div className="col">
                  <Field
                    name={`${mutationDetectionForm}.mutationdetectionsequence`}
                    component={MutationDetectionSequence}
                    index={index}
                    custom={custom}
                  />
                </div>
              )}

              {fields.length > 1 && (
                <div className="col-auto">
                  <a
                    alt="Remove"
                    title="Remove"
                    className="del-field"
                    href=""
                    onClick={(e) => (e.preventDefault(), fields.remove(index))}
                  >
                    <i className="fa fa-minus" aria-hidden="true"></i>
                  </a>
                </div>
              )}
            </div>
          </Fragment>
        );
      })}

      <div className="row">
        <div className="col">
          <div className="btn-add-target">
            <button
              className="outline rounded"
              onClick={(e) => (
                e.preventDefault(),
                fields.push({
                  

                  mutationdetectionidentifier: {
                    identifier: "",
                    fluorophores: "FAM/HEX",
                    assayFormat: "SingleTube",
                    created_at: epochDate,
                    assayType: "Mutation",
                  },

                  mutationdetectionsequence: {
                    assayTargetName: "",
                    genome: "Home sapiens",
                    fluorophores: "FAM/HEX",
                    created_at: epochDate,
                    assayType: "Mutation",
                  },
                })
              )}
            >
              <i className="fas fa-plus" />
              &nbsp;Add Target
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

MutationDetectionForm.propTypes = {
  formObj: PropTypes.object,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  actions: PropTypes.object,
};
const epochDate = new Date().getTime();
